import React from "react";

import * as Radio from "ds/Radio";

import { FormInputPropType } from "../type";

import * as S from "./styles";

const FormRadioGroupsInput = (config: FormInputPropType) => {
  return (
    <S.RadioGroupWrapper>
      <label className="radio-label" htmlFor={config.id}>
        {config.label}
      </label>
      <Radio.Group
        required
        defaultValue={config.value}
        onChange={config.onChange}
        name={config.name}
      >
        {config.options?.map(({ value, label }, k) => (
          <Radio.Input id={value} label={label} value={value} key={k} />
        ))}
      </Radio.Group>
    </S.RadioGroupWrapper>
  );
};

export default FormRadioGroupsInput;
